// 申込処理中止
import React from 'react';
import { render } from 'react-dom';
import Block from '../../molecules/Block';

const ReceptionAbort: React.FC = () => {
  return (
    <>
      <div className="mt-5"></div>
      <Block
        label="申込処理を中止しました。"
        content={
          <p>
            申込処理を中止しました。
            <br />
            再開する場合は、通知されたメールのURLよりアクセスして下さい。
          </p>
        }
      />
    </>
  );
};

if (document.getElementById('reception-abort')) {
  render(<ReceptionAbort />, document.getElementById('reception-abort'));
}
